import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store";

interface ILogOutOnlyProps {
    children : React.ReactNode;
}


export default function LogOutOnly({ children } : ILogOutOnlyProps) {

    const { isLoggedIn, isAdmin } = useAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if(isLoggedIn) {
            if(isAdmin) {
                navigate("/admin/main")
            } else {
                navigate("/home")
            }
        }
    }, [isLoggedIn, isAdmin, navigate])

    return (<> { children } </>)
    // 여기서 children은 component 안에 있는 Element들을 말함, 굳이 props로 넘겨받지 않아도 <ProtectedPage></ProtectedPage> 안에 포함시키면 그렇게 인식함
}